import { IDeleteControleServicosUseCase } from "../../../presentation/useCases/delete/delete_controle_servicos_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteControleServicosUseCase
 */

export class DeleteControleServicosUseCase implements IDeleteControleServicosUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async deleteControleServicos(id: number): Promise<void> {
    await this.repository.deleteControleServicos({ id });
  }
}
